const API = process.env.REACT_APP_ACCOUNTS_API || "https://api.accounts.clikkle.com/api";
export const clearLocalIdentity = () => {
  ["user","token","refreshToken","sessionToken"].forEach((key)=>localStorage.removeItem(key));
  document.cookie.split(";").forEach((cookie)=>{
    const name=cookie.split("=")[0].trim();
    if (/token|user|session|refresh/i.test(name)) document.cookie=`${name}=; Max-Age=0; path=/`;
  });
};
export async function validateCentralSession(){
  const refreshToken=localStorage.getItem("refreshToken")?.replace(/^"|"$/g,"");
  if(!refreshToken) return false;
  try{
    const response=await fetch(`${API}/auth/session/status`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({refreshToken})});
    if(!response.ok){ clearLocalIdentity(); return false; }
    const data=await response.json();
    if(!data?.success){ clearLocalIdentity(); return false; }
    return true;
  }catch{return true;}
}
